import { ShortMessageTemplatesState } from './partials/templates'

export const ShortMessageState = _ => ({
  ...ShortMessageTemplatesState,
})
